import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.79 21.421a.58.58 0 0 1-.58.58H.58A.58.58 0 0 1 0 21.42V7.526a.58.58 0 0 1 .579-.579H5.21a.58.58 0 0 1 .578.58V21.42ZM2.895 5.79A2.897 2.897 0 0 1 0 2.895 2.9 2.9 0 0 1 2.895 0a2.896 2.896 0 0 1 0 5.79M22 21.421a.58.58 0 0 1-.579.58H16.79a.58.58 0 0 1-.58-.58v-8.105a1.737 1.737 0 1 0-3.473 0v8.105a.58.58 0 0 1-.58.58h-4.63a.58.58 0 0 1-.58-.58V7.526a.58.58 0 0 1 .58-.579h4.63a.58.58 0 0 1 .58.58v.602a5.7 5.7 0 0 1 3.473-1.182 5.796 5.796 0 0 1 5.79 5.79z"
    }, null, -1)
  ]))]))
}
export default { render: render }